import { useCallback, useState, useEffect } from 'react';

export const useDebouncedEffect = (effect, delay, deps) => {
  const callback = useCallback(effect, deps);

  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [callback, delay]);
};

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    return timeout;
  };
};

/*
export const useDebouncedEffect = (effect, delay, deps) => {
  const callback = useCallback(effect, deps);

  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [callback, delay]);
};

export function useDebounceEffect(value, func, delay, skip1) {
  // State and setters for debounced value
  const [count, setCount] = useState(0);
  useEffect(
    () => {
      if (!skip1 || count > 0) {
        const handler = setTimeout(() => {
          func(value);
        }, delay);
        return () => {
          clearTimeout(handler);
        };
      } else {
        setCount(count + 1);
      }
    },
    [value, delay] // Only re-call effect if value or delay changes
  );
}
*/
